import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

const getRecurringDescription = (plan, behaviour) => {
    if (!plan) return "";

    // Repeat description
    let repeatText = "";

    if (plan.repeat?.repeatDaily) {
        const every = plan.repeat.repeatDaily.repeatEvery;

        if (every === 1) {
            repeatText = "every day";
        } else if (every === 2) {
            repeatText = "every alternate day";
        } else {
            repeatText = `every ${every} days`;
        }
    }

    if (plan.repeat?.repeatWeekly) {
        const days = plan.repeat.repeatWeekly.repeatOn.join(", ");

        repeatText =
            plan.repeat.repeatWeekly.repeatOn.length === 1
                ? `every ${days}`
                : `every week on ${days}`;
    }

    // End description
    let endText = "";

    switch (plan.planEndType) {
        case "OCCURRENCES":
            endText = `until ${plan.planEndValue} bookings have been created`;
            break;

        case "DAYS":
            endText = `for ${plan.planEndValue} day${plan.planEndValue > 1 ? "s" : ""}`;
            break;

        case "WEEKS":
            endText = `for ${plan.planEndValue} week${plan.planEndValue > 1 ? "s" : ""}`;
            break;

        default:
            endText = "";
    }

    return  behaviour === "before-booking"
        ? `Your first booking will be created for the selected appointment. The remaining bookings will be created automatically ${repeatText} and continue ${endText}.`
        : `This booking will repeat automatically ${repeatText} and continue ${endText}.`;
};

const RecurringBookingAlert = ({ recurringBookingPlan, alertProps, title, behaviour="before-booking" }) => {

    return (
        <Alert severity="info" sx={{ mb: 2 }} {...alertProps}>
            {title? <AlertTitle>{title}</AlertTitle> : null}
            {getRecurringDescription(recurringBookingPlan, behaviour)}
        </Alert>
    )
};

export default RecurringBookingAlert;